import { render } from "./Business_A.vue?vue&type=template&id=73ba08e0&scoped=true"
import script from "./Business_A.vue?vue&type=script&lang=js"
export * from "./Business_A.vue?vue&type=script&lang=js"

import "./Business_A.vue?vue&type=style&index=0&id=73ba08e0&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ba08e0"]])

export default __exports__